// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.


/* accordion mega menu*/
document.addEventListener("DOMContentLoaded", function () {
  const parents = document.querySelectorAll(".promo_box_mega_menu .meganav__list-parent > li.has-children");

  parents.forEach(parent => {
    const trigger = parent.querySelector("div > a");
    const submenu = parent.querySelector("ul[depth='1']");

    if (!trigger || !submenu) return;

    // Disable link and turn into toggle
    trigger.setAttribute("data-original-href", trigger.getAttribute("href"));
    trigger.setAttribute("href", "javascript:void(0)");

    // Start collapsed
    submenu.style.maxHeight = "0";
    submenu.style.overflow = "hidden";
    submenu.style.transition = "max-height 0.3s ease";

    trigger.addEventListener("click", function (e) {
      e.preventDefault();

      const isOpen = parent.classList.contains("open");

      // Close all other accordions
      parents.forEach(item => {
        if (item !== parent) {
          item.classList.remove("open");
          const otherSub = item.querySelector("ul[depth='1']");
          if (otherSub) {
            otherSub.style.maxHeight = "0";
          }
        }
      });

      // Toggle the clicked one
      if (isOpen) {
        parent.classList.remove("open");
        submenu.style.maxHeight = "0";
      } else {
        parent.classList.add("open");
        submenu.style.maxHeight = submenu.scrollHeight + "px";
      }
    });
  });
});